/**
 * Глобальный UI-state: открытые sheet'ы, модалы.
 */
import { create } from 'zustand';

type RefreshFn = () => unknown | Promise<unknown>;

interface UIState {
  profileSheetOpen: boolean;
  inboxSheetOpen: boolean;
  /** Текущая страница регистрирует функцию refetch — Shell её дергает по pull-to-refresh. */
  onRefresh: RefreshFn | null;
  openProfile: () => void;
  closeProfile: () => void;
  openInbox: () => void;
  closeInbox: () => void;
  setOnRefresh: (fn: RefreshFn | null) => void;
}

export const useUI = create<UIState>((set) => ({
  profileSheetOpen: false,
  inboxSheetOpen: false,
  onRefresh: null,
  openProfile: () => set({ profileSheetOpen: true, inboxSheetOpen: false }),
  closeProfile: () => set({ profileSheetOpen: false }),
  openInbox: () => set({ inboxSheetOpen: true, profileSheetOpen: false }),
  closeInbox: () => set({ inboxSheetOpen: false }),
  setOnRefresh: (fn) => set({ onRefresh: fn }),
}));
